//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import enroll from '@/assets/img/enroll.png'
import TServiceList from '@/TShareComponent/TServiceList'
import emptyNoticeIcon from '@/assets/img/notice_empty.png'
import emptyServiceIcon from '@/assets/img/service_empty.png'
import {
  queryBanner,
  queryNotice,
  queryService,
} from '@/https/user'
import CEmpty from '@/components/CEmpty'
import CTitle from '@/components/CTitle'
import TMenu from '@/TShareComponent/TMenu'

export default {
  name: 'Home',

  components: {
    TServiceList,
    TMenu,
    CTitle,
    CEmpty,
  },

  data () {
    return {
      emptyNoticeIcon,
      emptyServiceIcon,
      noticeLoading: false,
      bannerLoading: false,
      serviceLoading: false,
      bannerImages: [],
      noticeList: [],
      serviceList: [],
    }
  },

  created () {
    this.setBanner()
    this.setNotice()
    this.setService()
  },

  methods: {
    async setService () {
      this.serviceLoading = true
      const { data } = await queryService()
      this.serviceList = data.map((el) => {
        return {
          img: el.fwtb,
          name: el.fwmc,
          url: el.fwnr,
          ...el,
        }
      }) || []
      this.serviceLoading = false
    },

    async setBanner () {
      this.bannerLoading = true
      const { data } = await queryBanner()
      this.bannerImages = data || []
      this.bannerLoading = false
    },

    async setNotice () {
      this.noticeLoading = true
      const { data } = await queryNotice({
        zslbdm: '',
        limit: 3,
      })

      this.noticeList = data || []
      this.noticeLoading = false
    },

    handlerClickMoreNotice () {
      this.$router.push('/noticeList')
    },

    enterNoticeDetail (item) {
      this.$router.push({
        path: '/noticeDetail',
        query: { wid: item.wid },
      })
    },

  },
}
